import { FormBuilder, Validators } from '@angular/forms';
import { FormUtils } from '@bca-shared/shared.utils';
import { PaymentPeriod } from '@bca-agreement/models/_enums';

export const createAgreementForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    paymentPeriod: [PaymentPeriod.MONTHLY, Validators.required],
    issuer: formBuilder.group({
      id: [0, [Validators.required, FormUtils.Validators.select]],
      displayName: null
    }),
    authorizedDirectDebit: [false, FormUtils.Validators.checkBox],
    authorizedVerifyInfo: [false, FormUtils.Validators.checkBox],
    authorizedAgreementAndProductConditions: [
      false,
      FormUtils.Validators.checkBox
    ]
  });
};
